import { Anchor } from '@components/Anchor';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { useMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { AtividadeModal } from '@mod/Atividade/AtividadeModal';
import { FaturaCancelarModal } from '@mod/Fatura/FaturaCancelarModal';
import { FaturaDetalheModal } from '@mod/Fatura/FaturaDetalheModal';
import { FaturaMenu } from '@mod/Fatura/FaturaMenu';
import IFatura, { useFaturaTipoColor } from '@model/Fatura';
import { useFaturaStatusColor } from '@model/FaturaStatus';
import React from 'react';

export type InadimplenciaDetalhesTableProps = {
    data: IData<IFatura>
}

export function InadimplenciaDetalhesTable ({ data }: InadimplenciaDetalhesTableProps) {
    const formatter = useFormatter();
    const faturaDetalheModal = useModalWindow();
    const faturaStatusColor = useFaturaStatusColor();
    const faturaTipoColor = useFaturaTipoColor();
    const menu = useMenu();
    const cancelarModal = useModalWindow();
    const reabrirModal = useModalWindow();
    const desfazerCancelamentoModal = useModalWindow();
    const atividadeModal = useModalWindow();

    return (
        <React.Fragment>
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Empresa</TableHeaderCell>
                        <TableHeaderCell>Vencimento</TableHeaderCell>
                        <TableHeaderCell>Vlr. Total</TableHeaderCell>
                        <TableHeaderCell>Vlr. Pago</TableHeaderCell>
                        <TableHeaderCell>Saldo</TableHeaderCell>
                        <TableHeaderCell>Pagamento</TableHeaderCell>
                        <TableHeaderCell>Forma Pgto.</TableHeaderCell>
                        <TableHeaderCell>Avulsa</TableHeaderCell>
                        <TableHeaderCell>Status</TableHeaderCell>
                        <TableHeaderCellAction />
                    </TableRow>
                </TableHead>

                <TableBody>
                {
                    data.items.map((fatura, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell><Anchor onClick={data.handleRowFocused(fatura, faturaDetalheModal.open)}>{fatura.faturaId}</Anchor></TableKeyCell>
                                <TableCell>{fatura.empresaNome}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataVencimento)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorTotal)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorPago)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.saldo)}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataPagamento)}</TableCell>
                                <TableCell>{fatura.formaPagamentoNome}</TableCell>
                                <TableCell className={faturaTipoColor[fatura.tipo]}>
                                        { fatura.tipo }
                                </TableCell>
                                <TableCell className={faturaStatusColor[fatura.faturaStatusId]}>{fatura.faturaStatusNome}</TableCell>
                                <TableCellAction onButtonClick={data.handleRowFocused(fatura, menu.open)} />
                            </TableRow>
                        )
                    })
                }
                </TableBody>

            </TableNoResult>

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <FaturaMenu 
                            menu={menu} 
                            fatura={data.focusedRow} 
                            cancelarModal={cancelarModal}
                            reabrirModal={reabrirModal}
                            desfazerCancelamentoModal={desfazerCancelamentoModal}
                            atividadeModal={atividadeModal}
                        />

                        <FaturaDetalheModal 
                            faturaId={data.focusedRow.faturaId}
                            modal={faturaDetalheModal}
                        />

                        <FaturaCancelarModal 
                            modal={cancelarModal}
                            fatura={data.focusedRow}
                            onFaturaCancelada={data.handleUpdateFocusedRow}
                        />

                        <AtividadeModal 
                            modal={atividadeModal}
                            entidade='fatura'
                            chaves={{
                                faturaId: data.focusedRow.faturaId
                            }}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}